import { Link } from "react-router-dom";
import { gossipList } from "@/mocks/gossip";

export default function Ticker() {
  const items = gossipList.slice(0, 6);
  const loop = [...items, ...items];

  return (
    <div className="border-b border-background-200 bg-foreground-950 text-background-100">
      <div className="max-w-shell mx-auto flex items-stretch">
        <span className="shrink-0 flex items-center gap-2 px-4 md:px-6 py-3 bg-primary-600 text-background-50 text-xs font-medium tracking-wide">
          <i className="ri-pulse-line"></i>
          最新鉴定
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee">
            {loop.map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                to={`/gossip/${item.id}`}
                className="flex items-center gap-2 px-6 py-3 text-xs text-background-200 hover:text-accent-400 transition-colors whitespace-nowrap"
              >
                <span className="text-accent-400">{item.verdict}</span>
                <span>{item.title}</span>
                <span className="text-background-500">/</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}